import React, { useState } from 'react'
import {
    Form,
    Card,
    CardWithBreadcrumb,
    CancelButton,
    SaveButton,
    Tabs,
    Tab,
    Button,
    Dialog,
    Row,
    Col,
    H5,
    ResetButton,
    DangerButton,
    DeleteButton,
    CollapsableCard,
    Divider,
} from '../../../Elements'
import { CheckAddressDialog } from '../../CheckAddressDialog'
import { Classes, H6, Callout } from '@blueprintjs/core'
import JobInfoCard from '../../Job/JobForm/JobInfoCard'
import DocumentTree from '../../DocumentTree'
import { useMediaQuery } from 'react-responsive'
import _, { isEqual } from 'lodash'
import { Prompt } from 'react-router-dom'
import moment from 'moment'

const cardStyle = {
    minWidth: 300
}
const DEFAULT_TAB = 'job_info_tab'

const parseAddressArray = (address, lat, lon) => {
    return {
        line_1: `${address.street_number ? `${address.street_number} ` : ''}${address.road}`,
        city: address.city,
        county: address.county,
        state: address.state,
        zip: address.postal_code,
        lat: lat,
        lon: lon
    }
}

const setAddressFields = (setFieldValue, address) => {
    setFieldValue('address_line_1', address.line_1)
    setFieldValue('city', address.city)
    setFieldValue('county', address.county)
    setFieldValue('state', address.state)
    setFieldValue('zip_code', address.zip)
    setFieldValue('lat', address.lat)
    setFieldValue('lon', address.lon)
}

const ConvertToJobDialog = ({ convertToJobDialogOpen, setConvertToJobDialogIsOpen, submitForm, values }) => {
    return <Dialog
        icon='briefcase'
        title='Convert Estimate to Job'
        isOpen={convertToJobDialogOpen}
        canOutsideClickClose={false}
        canEscapeKeyClose={false}
        isCloseButtonShown={false}
    ><Form>
            <div className={Classes.DIALOG_BODY}>
                <Card>
                    <Row>
                        <Col xs={12}>
                            <H5>{`Are you sure you want to convert the estimate `} <span style={{ color: 'red' }}>{values.name}</span> {` to a job?`}</H5>
                        </Col>
                    </Row>
                </Card>
            </div>
            <div className={Classes.DIALOG_FOOTER}>
                <div className={Classes.DIALOG_FOOTER_ACTIONS} style={{ marginRight: '10px' }}>
                    <Button text='Convert' intent='success' icon='briefcase' onClick={() => { convertJob({ setConvertToJobDialogIsOpen, submitForm, values }) }} />
                    <CancelButton onClick={() => setConvertToJobDialogIsOpen(false)} />
                </div>
            </div>
        </Form>
    </Dialog>

}

const convertJob = ({ setConvertToJobDialogIsOpen, submitForm, values }) => {
    //Set dialog to closed
    setConvertToJobDialogIsOpen(false)

    //update is_estimate to false
    values.is_estimate = false
    values.was_estimated = true

    //Add field to help determine where to navigate when save is completed
    values.is_conversion = true

    submitForm()
}

export default ({ deleteDialogIsOpen, setDeleteDialogIsOpen, user, allowApproveEditDelete, approvedBy, setApprovedBy, isNew,
    isSubmitting, values = {}, dirty, lookupOptions = {}, supervisors, homeowners, submitForm, validateForm, previousTabState,
    presaveDialogIsOpen, setPresaveDialogIsOpen, presaveCheckResults, onSaveEstimate, documentTags, ...props }) => {

    const [tabState, setTabState] = useState(previousTabState || DEFAULT_TAB)
    const [convertToJobDialogOpen, setConvertToJobDialogIsOpen] = useState(false)
    const [addressDialogIsOpen, setAddressDialogIsOpen] = useState(false)
    const [lastAddress, setLastAddress] = useState({
        line_1: values.address_line_1,
        city: values.city,
        county: values.county,
        state: values.state,
        zip: values.zip_code,
        lat: values.lat,
        lon: values.lon
    })

    // handles conditional rendering of UI elements that are only available based on estimate type (regular/preliminary),
    // approval status, and user permissions
    const shouldRenderElement = (componentName) => {

        // for UI purposes, estimates where is_preliminary ==== true && the estimate is NOT approved, are treated as 'Preliminary'...
        // ...so this is our working definition of "preliminary" from the user's perspective
        const isEstimatePreliminary = (estimate) => estimate.is_preliminary && !estimate.is_approved_by_user_id

        const shouldRender = {
            Callout: isEstimatePreliminary(values),

            // save button available for: 
            SaveButton: true,
            // //  (a) non-preliminary estimates OR     
            // !isEstimatePreliminary(values) ||
            // //(b) preliminary estimates where user has reviewer rights
            // (isEstimatePreliminary(values) && allowApproveEditDelete),

            // delete button available for: 
            DeleteButton:
                // preliminary estimates where user has reviewer rights
                allowApproveEditDelete,

            // 'Approve Estimate' Switch control available for:
            // is_preliminary === true && user has reviewer rights (and can thus revoke approval via the Switch control)
            ApproveButton: values.is_preliminary && allowApproveEditDelete && isEstimatePreliminary(values)
        }

        return shouldRender[componentName]
    }

    const selectAddress = (address) => {
        setAddressDialogIsOpen(false)
        if (!address) return
        const addressObject = parseAddressArray(address.address, address.lat, address.lon)
        setAddressFields(props.setFieldValue, addressObject)
        setLastAddress(addressObject)
    }

    const isAddressValidated = (lastAddress.line_1 === values.address_line_1 &&
        lastAddress.city === values.city &&
        lastAddress.county === values.county &&
        lastAddress.state === values.state &&
        lastAddress.zip === values.zip_code &&
        !(values.lat === null || values.lat === undefined) &&
        !(values.lon === null || values.lon === undefined)) &&
        lastAddress.lat && lastAddress.lat.toString() === values.lat.toString() &&
        lastAddress.lon && lastAddress.lon.toString() === values.lon.toString()

    if (isAddressValidated !== values.isValidAddress) {
        props.initialValues.isValidAddress = props.initialValues.isValidAddress || isAddressValidated
        props.setFieldValue('isValidAddress', isAddressValidated)
    }
    const mappedSupervisors = supervisors.map(c => ({
        ...c,
        name: `${c.first_name} ${c.last_name}`
    })).filter(e => values?.company?.id?.toString() === e?.customer_id)

    const mappedHomeowners = homeowners.map(c => ({
        ...c,
        name: `${c.first_name} ${c.last_name}`
    }))

    values.tabState = tabState

    const breadCrumbItems = [{ text: 'Estimates', to: '/estimate', icon: 'calculator' }, { text: values.name }]
    const isMobile = useMediaQuery({ query: '(max-width: 800px)' })
    const convertbuttonStyle = { padding: '.5em 1.3em', margin: '0 .25em' }

    const userConfirmedSaveAsNew = () => {
        props.setSubmitting(true)
        onSaveEstimate(values)
    }
    return (
        <Form>
            <Dialog
                icon='trash'
                title='Delete Estimate?'
                isOpen={deleteDialogIsOpen}
                canOutsideClickClose={true}
                canEscapeKeyClose={true}
                isCloseButtonShown={true}
                onClose={() => setDeleteDialogIsOpen(false)}
            >
                <div className={Classes.DIALOG_BODY}>
                    <p>Are you sure you want to delete this estimate? It cannot be reversed</p>
                    <DeleteButton onClick={props.onDelete} />
                </div>
            </Dialog>
            <Dialog
                icon='issue-new'
                title='Potential Duplicate(s) Detected'
                isOpen={presaveDialogIsOpen}
                canOutsideClickClose={false}
                canEscapeKeyClose={false}
                isCloseButtonShown={false}
            ><Form>
                    <div className={Classes.DIALOG_BODY} style={{ maxHeight: '70vh', overflowY: 'scroll' }}>
                        {presaveCheckResults && presaveCheckResults.map(r => <PotentialDuplicateEstimateCard potentialDuplicateEstimate={r} />)}
                    </div>
                    <div className={Classes.DIALOG_FOOTER}>
                        <div className={Classes.DIALOG_FOOTER_ACTIONS} style={{ marginRight: '10px' }}>
                            <DangerButton icon='disable' text={!isMobile && 'Cancel'} onClick={() => setPresaveDialogIsOpen(false)} />
                            <Button text='Save As New Estimate' intent='success' icon='saved' onClick={() => userConfirmedSaveAsNew(values)} />
                        </div>
                    </div>
                </Form>
            </Dialog>

            <Prompt
                when={!isSubmitting && !isEqual(props.initialValues, values)}
                message={'You have unsaved changes. Navigate away?'}
            />
            {shouldRenderElement('Callout') && <Callout
                // if user can approve & edit, just tag the estimate as preliminary; otherwise...additional message
                title='Preliminary Estimate'
                icon={allowApproveEditDelete ? 'issue-closed' : 'warning-sign'}
                intent={allowApproveEditDelete ? 'success' : 'warning'}>
                <b>{allowApproveEditDelete ?
                    'Approve estimate to promote & enable conversion to job'
                    : 'Estimate is preliminary and requires supervisor approval.'}
                </b>
            </Callout>
            }
            <CardWithBreadcrumb items={breadCrumbItems} isMobile={isMobile}>
                {shouldRenderElement('ApproveButton') && <Button
                    intent='success'
                    icon='tick'
                    text={!isMobile && 'Approve'}
                    style={convertbuttonStyle}
                    onClick={() => {
                        setApprovedBy(user.id)
                        values.is_approved_by_user_id = user.id
                        props.onApprovalChange(values)
                    }}
                />}
                {(!isNew && (values.is_approved_by_user_id || !values.is_preliminary)) &&
                    <Button
                        intent='primary'
                        icon='briefcase'
                        text={!isMobile && 'Convert to Job'}
                        style={convertbuttonStyle}
                        onClick={() => { validateForm().then((res) => setConvertToJobDialogIsOpen(_.isEmpty(res))) }}
                    />
                }
                <ResetButton onClick={props.onCancel} isMobile={isMobile} />
                {shouldRenderElement('SaveButton') &&
                    <SaveButton isMobile={isMobile} disabled={isSubmitting} />}
                {shouldRenderElement('DeleteButton') &&
                    <DeleteButton onClick={() => setDeleteDialogIsOpen(true)} isMobile={isMobile} />
                }
            </CardWithBreadcrumb>
            <CheckAddressDialog
                values={values}
                save={(evt) => selectAddress(evt)}
                cancel={() => setAddressDialogIsOpen(false)}
                isOpen={addressDialogIsOpen}
                setIsOpen={(newState) => setAddressDialogIsOpen(newState)}
                enableCheckForDuplicates={true} //enabled for estimateCreation and estimateEdit
            />
            {convertToJobDialogOpen && <ConvertToJobDialog
                convertToJobDialogOpen={convertToJobDialogOpen}
                setConvertToJobDialogIsOpen={setConvertToJobDialogIsOpen}
                submitForm={submitForm}
                values={values}
            />}
            <Card style={cardStyle}>
                <Divider />
                <Tabs
                    id="estimate_form_tabs"
                    onChange={setTabState}
                    selectedTabId={tabState}
                >
                    <Tab
                        id="job_info_tab"
                        title="Job Info"
                        panelClassName=''
                        panel={<JobInfoCard
                            dirty={dirty}
                            supervisors={mappedSupervisors}
                            homeowners={mappedHomeowners}
                            values={values}
                            onCheckAddressClicked={setAddressDialogIsOpen}
                            {...props}
                        />}
                    />
                    <Tab
                        id="document_tab"
                        title="Documents"
                        panel=
                        {
                            <DocumentTree
                                values={values}
                                isEstimate={true}
                                documentTags={documentTags}
                            />
                        }
                        disabled={values.id == null || values.id === 0}
                    />
                </Tabs>
            </Card>
        </Form>
    )
}

export const PotentialDuplicateEstimateCard = ({ potentialDuplicateEstimate }) => {
    return <CollapsableCard
        title={`${potentialDuplicateEstimate.name} (${potentialDuplicateEstimate.id})`}
        defaultAsClosed
        icon='eye-open'
        iconProps={{ onClick: () => window.open(`/estimate/${potentialDuplicateEstimate.id}/edit`, '_blank') }}
    >
        <Row style={{ margin: 10 }}>
            <Col xs={12}>
                <Row>
                    <Col xs={6}>
                        <H6>Address:</H6>
                    </Col>
                    <Col xs={6}>
                        <H6>{potentialDuplicateEstimate.address_line_1 || '---'}</H6>
                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <H6>City:</H6>
                    </Col>
                    <Col xs={6}>
                        <H6>{potentialDuplicateEstimate.city || '---'}</H6>
                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <H6>Date Entered:</H6>
                    </Col>
                    <Col xs={6}>
                        <H6>{potentialDuplicateEstimate.entered_date ? moment(potentialDuplicateEstimate.entered_date).format('MM/DD/YYYY') : '---'}</H6>
                    </Col>
                </Row>
            </Col>
        </Row>
    </CollapsableCard>
}